export default __webpack_public_path__ + "static/media/sobreEC.24153893.svg";